import React, { useEffect, useMemo, useState } from 'react';
import { Select, FormControl } from '@material-ui/core';
import { BaseTextField } from '../../BaseTextField/BaseTextField';

import { ITEM_HEIGHT, ITEM_PADDING_TOP } from '../common/helpers';
import { SelectMenu } from '../common/SelectMenu/SelectMenu';
import { SelectLoader } from '../BaseMultiSelect/SelectLoader';
import { SelectOption } from './SelectOption';
import { ISelectOption, PSelect, selectValueType } from '../common/types';

const getObjOptions = (optionsList: Array<any>) => {
  const optionsObj = {};
  optionsList.forEach((option) => {
    // @ts-ignore
    optionsObj[option.value] = option;
  });
  return optionsObj;
};

export type PBaseSelect = PSelect<selectValueType> & {
  withoutSearch?: boolean;
};

export const BaseSelect: React.FC<PBaseSelect> = (props) => {
  const {
    value,
    options,
    placeholder,
    label,
    loading,
    onChange,
    errorText,
	disabled,
    withoutSearch = false,
    ...otherProps
  } = props;

  // Create obj for optimization. We are getting option object without additional loops
  // In this case we prevent O(n2) algorithmic efficiency
  const objOptions = useMemo(() => getObjOptions(options), [options]);

  const [currentOption, setCurrentOption] = useState<ISelectOption | null>(
    null,
  );
  const [open, selectHandleOnOpen] = React.useState(false);

  const MenuProps = {
    MenuListProps: {
      component: SelectMenu,
      selectMenuData: {
        OptionComponent: SelectOption,
        onClick: (newValue: any) => {
          onChange(newValue);
          selectHandleOnOpen(false);
        },
        selected: value,
        options,
      },
      withoutSearch,
    },
    anchorOrigin: {
      vertical: 'bottom',
      horizontal: 'left',
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'left',
    },
    getContentAnchorEl: null,
    PaperProps: {
      style: {
        paddingTop: ITEM_PADDING_TOP,
        maxHeight: ITEM_HEIGHT * 8 + ITEM_PADDING_TOP,
      },
    },
  };

  /* useEffect(() => {
    // @ts-ignore
    if (typeof objOptions[value] !== 'undefined') {
      // @ts-ignore
      setCurrentOption(objOptions[value]);
    }
  }, [value, objOptions]); */
  // @ts-ignore
  
  useEffect(() => {
	  if(!value) {
		  setCurrentOption(null);
		  return;
	  }
	  if(objOptions[value]) {
		  setCurrentOption(objOptions[value]);
	  }
  }, [value, objOptions]);
  // @ts-ignore
  return (
    <FormControl {...otherProps}>
      <Select
        // @ts-ignore
		displayEmpty
		disabled={disabled}
        MenuProps={MenuProps}
        style={{ width: '100%' }}
        value={value}
        open={disabled ? false : open}
        onClick={() => {
			if(!disabled) {
				selectHandleOnOpen((prev) => !prev);
			}
		}}
        renderValue={() => {
			if(!currentOption) {
				return (
					<span style={{ color: disabled ? "#BDBDBD" : "#000000", }}>
						{placeholder}
					</span>
				);
			}
			return <span>{currentOption?.label}</span>;
        }}
        input={
          <BaseTextField
            label={label}
            placeholder={placeholder}
            InputProps={{
              endAdornment: <>{loading ? <SelectLoader /> : null}</>,
			  style: {
				  backgroundColor: disabled ? "#F5F5F5" : "#FCFCFC",
			  },
            }}
            errorText={errorText}
          />
        }
      />
    </FormControl>
  );
};
